import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Translate } from 'react-localize-redux'

import { title as titleClassname, image } from './LinkedProduct.module.scss'

/*
TODO: ficar titol en 2/3 linies: subcategoria + color + disseny
*/

const LinkedProduct = ({
  heroImage,
  isNew,
  isPreorder,
  pagePath,
  title,
  previewHeroImage,
}) => {
  return (
    <div className="relative mb-10 md:mb-0 text-sm leading-tight">
      <div className={`relative mb-3 md:mb-4 ${image}`}>
        {isNew && (
          <div className="flex items-center justify-center absolute top-0 right-0 mt-4 mr-4 rounded-full bg-harvest-gold w-10 h-10 pointer-events-none z-10">
            <span className="uppercase text-xs leading-none">New</span>
          </div>
        )}
        {heroImage && (
          <GatsbyImage
            image={heroImage}
            alt={title}
            backgroundColor="#F0D7C3"
          />
        )}
        {previewHeroImage && (
          <img src={previewHeroImage} alt={title} className="w-full h-auto" />
        )}
      </div>
      {isPreorder && (
        <div className="my-2 text-xs lg:text-sm uppercase leading-none text-fern-green">
          <Translate id="availableForPreorder" />
        </div>
      )}
      <div className={titleClassname}>
        <Link to={`/${pagePath}`}>{title}</Link>
      </div>
    </div>
  )
}

LinkedProduct.propTypes = {
  heroImage: PropTypes.object,
  isNew: PropTypes.bool,
  isPreorder: PropTypes.bool,
  pagePath: PropTypes.string,
  previewHeroImage: PropTypes.string,
  title: PropTypes.string,
}

LinkedProduct.defaultProps = {
  heroImage: null,
  isNew: false,
  isPreorder: false,
  pagePath: '',
  previewHeroImage: undefined,
  title: '',
}

export default LinkedProduct
